const translation = {
  daysInWeek: {
    Fri: 'เสรี',
    Sat: 'เสาร์',
    Wed: 'วันพุธ',
    Sun: 'ดวงอาทิตย์',
    Tue: 'อังคาร',
    Thu: 'วันพฤหัสบดี',
    Mon: 'มอน',
  },
  months: {
    February: 'กุมภาพันธ์',
    July: 'กรกฎาคม',
    June: 'มิถุนายน',
    January: 'มกราคม',
    September: 'กันยายน',
    August: 'สิงหาคม',
    October: 'ตุลาคม',
    May: 'พฤษภาคม',
    November: 'พฤศจิกายน',
    March: 'มีนาคม',
    December: 'ธันวาคม',
    April: 'เมษายน',
  },
  operation: {
    ok: 'ตกลง',
    cancel: 'ยกเลิก',
    pickDate: 'เลือกวันที่',
    now: 'ตอนนี้',
  },
  title: {
    pickTime: 'เลือกเวลา',
  },
  defaultPlaceholder: 'เลือกเวลา...',
}

export default translation
